// Supabase auth errors arrive as raw English strings ("Invalid login
// credentials", "User already registered", …). Rendering them verbatim shows
// English to Norwegian users on the highest-traffic error surface in the app,
// so map the known cases to i18n keys and fall back to a generic localized
// message. Takes the caller's `t` (from useI18n) instead of importing the
// global instance, so components stay testable with a mocked vue-i18n.
const PATTERNS: Array<[RegExp, string]> = [
  [/invalid login credentials|invalid_credentials/i, "invalid_credentials"],
  [/already registered|already exists|user_already_exists|email_exists/i, "user_exists"],
  [/email not confirmed|email_not_confirmed/i, "email_not_confirmed"],
  [/password should be|weak.?password|at least 6/i, "weak_password"],
  [/rate limit|too many requests/i, "rate_limited"],
  [/invalid email|unable to validate email|email_address_invalid/i, "invalid_email"],
  [/failed to fetch|networkerror|network error|load failed|timed out|timeout/i, "network"],
]

type Translate = (key: string) => string

export function localizeAuthError(error: unknown, t: Translate): string {
  const code = (error as { code?: unknown })?.code
  const message = error instanceof Error ? error.message : typeof error === "string" ? error : ""
  const haystack = `${typeof code === "string" ? code : ""} ${message}`
  for (const [pattern, key] of PATTERNS) {
    if (pattern.test(haystack)) return t(`auth.errors.${key}`)
  }
  return t("auth.errors.generic")
}
